@switch (mode) {
    @case (MODE.MODE_TOUR_LIST) {
        <page-hotel-tours-list/>
    }
    @case (MODE.MODE_PRICE_CALENDAR) {
        <page-manager-offer/>
    }
    @case (MODE.MODE_SEARCH) {
        <page-find-tours/>
    }
    @default {
    }
}
